import { useEffect } from "react";
import { Container, Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./usageMetrics.module.scss";
import ReportListView from "components/features/CardListView";
import _ from "lodash";
import { fetchAssetsMetrics, fetchDatasourceMappingMetrics } from "actions/metrics";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { formatTimeTaken } from "components/features/Util/Util";

export default function UsageMetrics() {
  const dispatch = useDispatch();
  const history = useHistory();
  const DefaultAssetIcon = "/images/default_account_background.png";
  const page = 0;

  const assetsMetrics = useSelector((state) => _.get(state, "metrics.assetsMetrics.items", []));
  const assetLoading = useSelector((state) => _.get(state, "metrics.assetsMetrics.loading", false));
  const assetPagination = useSelector((state) => _.get(state, "metrics.assetsMetrics.pagination", { currentPage: 0, totalPages: 0, recordsPerPage: 20, totalRecordsCount: 0, }));
  const datasourceMappingMetrics = useSelector((state) => _.get(state, "metrics.datasourceMappingMetrics.items", []));
  const mappingLoading = useSelector((state) => _.get(state, "metrics.datasourceMappingMetrics.loading", false));
  const mappingPagination = useSelector((state) => _.get(state, "metrics.datasourceMappingMetrics.pagination", { currentPage: 0, totalPages: 0, recordsPerPage: 20, totalRecordsCount: 0 }));

  useEffect(() => {
    dispatch(fetchAssetsMetrics({ page, limit: 20 }));
    dispatch(fetchDatasourceMappingMetrics({ page, limit: 20 }));    
  }, [page, dispatch]);

  const handleAssetProcessingClick = (accountId) => {

    let path = `/paperflite/accounts/${accountId}/Assets`;
    history.push({
      pathname: path
    });
  };

  const handleDatasourceProcessingClick = (accountId) => {
    let path = `/paperflite/accounts/${accountId}/datasource`;
    history.push({
      pathname: path
    });
  };

  const handleLoadMore = (assetType) => {
    switch (assetType) {
      case "fetchTopAssetProcessingMetrics":
        if (assetPagination.currentPage < assetPagination.totalPages) {
          dispatch(
            fetchAssetsMetrics({
              page: assetPagination.currentPage + 1,
              limit: 20,
            })
          );
        }
        break;
      case "fetchTopDatasourceMappingMetrics":
        if (mappingPagination.currentPage < mappingPagination.totalPages) {
          dispatch(
            fetchDatasourceMappingMetrics({
              page: mappingPagination.currentPage + 1,
              limit: 20,
            })
          );
        }
        break;
      default:
        break;
    }
  };

  const handleViewMore = (assetType) => {
    switch (assetType) {
      case "fetchTopAssetProcessingMetrics":
        dispatch(
          fetchAssetsMetrics({
            page: 0,
            limit: 20,
          })
        );
        break;
      case "fetchTopDatasourceMappingMetrics":
        dispatch(
          fetchDatasourceMappingMetrics({
            page: 0,
            limit: 20,
          })
        );
        break;
      default:
        break;
    }
  };

  return (
    <Container className={styles.container}>
      <Grid>
        <Grid.Row className={styles.productMetricsRow} columns={2}>
          <Grid.Column className={styles.cardStyle}>
            <div className={styles.reportListView}>
              {assetLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Loader active inline="centered" size="large" />
                </div>
              )}
              <ReportListView
                title={`Top Account Assets In Processing (${assetPagination.totalRecordsCount || 0})`}
                description="Top account assets transaction in processing status"
                loading={assetLoading}
                items={assetsMetrics}
                pagination={assetPagination}
                loadMore={() => handleLoadMore("fetchTopAssetProcessingMetrics")}
                viewMore={() => handleViewMore("fetchTopAssetProcessingMetrics")}
                renderListItem={({ item, colCount }) => {
                  return (
                    <div key={item.accountId} className={styles.tableRow} onClick={() => handleAssetProcessingClick(item.accountId)}>
                      <div className={styles.tableDataContainer}>
                        <img
                          src={item.logo || DefaultAssetIcon}
                          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
                          alt={item.accountName || "Asset"}
                        />
                        <div className={styles.rightData}>
                          <div className={styles.account}>
                            <span className={styles.title} title={item.accountName}>{item.accountName}</span>
                          </div>
                          <span className={styles.metricsData}>
                            <span className={styles.name}>Subscription: {item.subscription || "N/A"}</span>
                          </span>
                        </div>
                      </div>
                      <div
                        className={styles.analyticsContainer}
                        style={{
                          gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
                        }}
                      >
                        <div className={styles.tableDataViews}>{item.assetCount || 0}</div>
                        <div className={styles.tableDataTime}>
                          {item.maxTotalTime != null ? `~${formatTimeTaken(item.maxTotalTime)}` : "0"}
                        </div>
                        <div className={styles.tableDataShares}>{item.errorAssetCount || 0}</div>
                      </div>
                    </div>
                  );
                }}
                columns={["# of Assets", "Max Time", "# of Errors"]}
                firstColumn="Top Accounts"
              />
            </div>
          </Grid.Column>
          <Grid.Column className={styles.cardStyle}>
            <div style={{ position: "relative" }}>
              {mappingLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Loader active inline="centered" size="large" />
                </div>
              )}
              <ReportListView
                title={`Top Account Datasource Mapping In Processing (${mappingPagination.totalRecordsCount || 0})`}
                description="Top account datasource mapping in processing status"
                loading={mappingLoading}
                items={datasourceMappingMetrics}
                pagination={mappingPagination}
                loadMore={() => handleLoadMore("fetchTopDatasourceMappingMetrics")}
                viewMore={() => handleViewMore("fetchTopDatasourceMappingMetrics")}
                renderListItem={({ item }) => {
                  return (
                    <div key={item.accountId} className={styles.tableRow} onClick={() => handleDatasourceProcessingClick(item.accountId)}>
                      <div className={styles.tableDataContainer}>
                        <img
                          src={item.logo || DefaultAssetIcon}
                          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
                          alt={item.accountName || "Asset"}
                        />
                        <div className={styles.rightData}>
                         <div className={styles.account}>
                            <span className={styles.title} title={item.accountName}>{item.accountName}</span>
                          </div>
                          <span className={styles.metricsData}>
                            <span className={styles.name}>Subscription: {item.subscription || "N/A"}</span>
                          </span>
                        </div>
                      </div>
                      <div
                        className={styles.analyticsContainer}
                      >
                        <div className={styles.tableDataViews}>{item.mappingsCount || 0}</div>
                        <div className={styles.tableDataViews}>{item.autoSyncMappingsCount || 0}</div>
                        <div className={styles.tableDataShares}>{item.manualSyncMappingsCount || 0}</div>
                      </div>
                    </div>
                  );
                }}
                columns={["# of Mappings", "# of Auto Sync", "# of Manual Sync"]}
                firstColumn="Top Accounts"
              />
            </div>

          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );

}